export default {
    approvals: "Zatwierdzenia",
    delegates: "Delegaci",
    employees: "Pracownicy"
}